import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const close = () => setActiveModal(null);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-10 text-center text-sm" data-id="element-29">
        <div className="container mx-auto px-4" data-id="element-30">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-6" data-id="element-31">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-32">
              Política de Privacidad
            </button>
            <span className="hidden md:inline text-gray-700" data-id="element-33">•</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-34">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-35">
            © {new Date().getFullYear()} El Código de la Longevidad. Todos los
            derechos reservados.
          </p>
          <p className="mt-3 text-xs max-w-2xl mx-auto text-gray-500" data-id="element-36">
            Este producto es de carácter educativo e informativo y no sustituye
            el consejo médico profesional. Consulte a su médico antes de
            comenzar cualquier programa de salud o nutrición.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={close} title="Política de Privacidad" data-id="element-37">
        <p data-id="element-38">
          En <strong data-id="element-39">El Código de la Longevidad</strong> respetamos su
          privacidad y nos comprometemos a proteger la información personal que
          usted comparte con nosotros.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-40">
          1. Información que recopilamos
        </h3>
        <p data-id="element-41">
          Recopilamos únicamente la información necesaria para procesar su
          compra y entregar el producto digital: nombre, correo electrónico y
          datos de pago (procesados de forma segura por nuestros proveedores).
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-42">
          2. Uso de la información
        </h3>
        <p data-id="element-43">Su información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-44">
          <li data-id="element-45">Entregar el producto digital adquirido.</li>
          <li data-id="element-46">Enviar confirmaciones de compra y soporte relacionado.</li>
          <li data-id="element-47">Cumplir con obligaciones legales y fiscales.</li>
        </ul>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-48">
          3. Compartir información
        </h3>
        <p data-id="element-49">
          No vendemos, alquilamos ni compartimos su información personal con
          terceros, excepto cuando sea necesario para procesar su pago o cuando
          la ley lo requiera.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-50">4. Seguridad</h3>
        <p data-id="element-51">
          Implementamos medidas técnicas y organizativas razonables para
          proteger su información contra accesos no autorizados, pérdida o
          alteración.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-52">5. Cookies</h3>
        <p data-id="element-53">
          Nuestro sitio puede usar cookies para mejorar su experiencia. Usted
          puede desactivarlas desde la configuración de su navegador.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-54">
          6. Cambios a esta política
        </h3>
        <p data-id="element-55">
          Nos reservamos el derecho de actualizar esta política. La versión más
          reciente siempre estará publicada en este sitio.
        </p>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={close} title="Términos y Condiciones" data-id="element-56">
        <p data-id="element-57">
          Al realizar una compra en este sitio, usted acepta los siguientes
          términos y condiciones. Le pedimos leerlos cuidadosamente.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-58">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-59">
          <strong data-id="element-60">El Código de la Longevidad: Metabolismo 55+</strong> es un
          producto digital en formato PDF de carácter educativo e informativo.
          No constituye consejo médico, diagnóstico ni tratamiento.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-61">
          2. Entrega del producto
        </h3>
        <p data-id="element-62">
          Una vez confirmado el pago, recibirá un enlace de descarga en el
          correo electrónico proporcionado. La entrega es inmediata y
          automática.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-63">3. Pago único</h3>
        <p data-id="element-64">
          La compra es un pago único de $6.39 USD. No existen suscripciones,
          cargos recurrentes ni costos ocultos.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-65">
          4. Política de reembolso
        </h3>
        <p data-id="element-66">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Le invitamos a leer la descripción
          completa antes de comprar.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-67">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-68">
          Todo el contenido del producto está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución o reventa sin
          autorización expresa.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-69">
          6. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-70">
          Los resultados pueden variar de persona a persona. Antes de aplicar
          cualquier recomendación del protocolo, consulte a su médico,
          especialmente si padece alguna condición de salud o toma medicamentos.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-71">
          7. Limitación de responsabilidad
        </h3>
        <p data-id="element-72">
          No nos hacemos responsables por daños directos o indirectos derivados
          del uso del producto. La aplicación de la información es
          responsabilidad exclusiva del usuario.
        </p>

        <h3 className="text-lg font-bold text-gray-900 mt-6" data-id="element-73">
          8. Modificaciones
        </h3>
        <p data-id="element-74">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. La versión vigente será siempre la publicada en este sitio.
        </p>
      </LegalModal>
    </>;
}